import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import countryList from "react-select-country-list";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import PhoneInputDropdown from "./PhoneInputDropdown";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { labelStyle } from "./styles";
import {
  Form,
  Input,
  Select,
  Row,
  Col,
  Typography,
} from "antd";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const { Option } = Select;

class ShipperBasicForm extends React.Component {
  state = {
    //showCustomBrokerInput: false,
  };


  // Custom validation function using libphonenumber-js
  validatePhoneNumber = (rule, value) => {
    if (!value) {
      return Promise.reject('Phone number is required!');
    }

    const phoneNumber = parsePhoneNumberFromString(value);
    
    if (!phoneNumber || !phoneNumber.isValid()) {
      return Promise.reject('Invalid phone number!');
    }

    return Promise.resolve();
  };


  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { initialFormData } = this.props; // Access initialFormData from props

    const options = countryList().getData();

    return (
      <div>
        <Row
          type="flex"
          md={{ justify: "space-between" }}
          xs={{ justify: "center" }}
          sm={{ justify: "center" }}
          gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
        >
          <Col xs={24} sm={24} md={12}>
            <Form.Item label={<span style={labelStyle}>E-mail</span>}>
              {getFieldDecorator("email", {
                initialValue: initialFormData.email,
                rules: [
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  {
                    required: true,
                    message: "E-mail is required",
                  },
                ],
              })(<Input size="large" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Form.Item label={<span style={labelStyle}>Company Name</span>}>
            {getFieldDecorator("company_name", {
              initialValue: initialFormData.company_name,
              rules: [
                { required: true, message: "Please input your company name!" },
              ],
            })(<Input size="large" />)}
          </Form.Item>
        </Row>
        <Form.Item label={<span style={labelStyle}>Address</span>}>
          <Form.Item>
            {getFieldDecorator("street", {
              initialValue: initialFormData.street,
              rules: [{ required: true, message: "Required" }],
            })(<Input size="large" placeholder="Street Address" />)}
          </Form.Item>

          <Form.Item>
            {getFieldDecorator("address", {
              initialValue: initialFormData.address,
              rules: [{ required: true, message: "Required" }],
            })(<Input size="large" placeholder="Address Line 2" />)}
          </Form.Item>

          <Row
            type="flex"
            md={{ justify: "space-between" }}
            xs={{ justify: "center" }}
            sm={{ justify: "center" }}
            gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
          >
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("city", {
                  initialValue: initialFormData.city,
                  rules: [{ required: true, message: "Required" }],
                })(<Input size="large" placeholder="City" />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("state", {
                  initialValue: initialFormData.state,
                  rules: [{ required: false }],
                })(<Input size="large" placeholder="State / Province" />)}
              </Form.Item>
            </Col>
          </Row>
          <Row
            type="flex"
            md={{ justify: "space-between" }}
            xs={{ justify: "center" }}
            sm={{ justify: "center" }}
            gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
          >
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("postal", {
                  initialValue: initialFormData.postal,
                  rules: [{ required: false }],
                })(<Input size="large" placeholder="ZIP / Postal Code" />)}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={12}>
              <Form.Item>
                {getFieldDecorator("country", {
                  initialValue:
                    initialFormData.country !== ""
                      ? initialFormData.country
                      : undefined,
                  rules: [
                    {
                      required: false,
                      //message: 'Please input first name',
                    },
                  ],
                })(
                  <Select
                    name="country"
                    placeholder="Select Country"
                    size="large"
                  >
                    {options.map((country) => (
                      <Option key={country} value={country.label}>
                        {country.label}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Row
          type="flex"
          md={{ justify: "space-between" }}
          xs={{ justify: "center" }}
          sm={{ justify: "center" }}
          gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
        >
          <Col xs={24} sm={24} md={12}>
            <Form.Item label={<span style={labelStyle}>First Name</span>}>
              {getFieldDecorator("customer_first_name", {
                initialValue: initialFormData.customer_first_name,
                rules: [
                  {
                    required: true,
                    message: "Please input first name",
                  },
                ],
              })(<Input size="large" placeholder="First Name" />)}
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={12}>
            <Form.Item label={<span style={labelStyle}>Last Name</span>}>
              {getFieldDecorator("customer_last_name", {
                initialValue: initialFormData.customer_last_name,
                rules: [
                  {
                    required: true,
                    message: "Please input last name",
                  },
                ],
              })(<Input size="large" placeholder="Last Name" />)}
            </Form.Item>
          </Col>
        </Row>

        <Row
          type="flex"
          md={{ justify: "space-between" }}
          xs={{ justify: "center" }}
          sm={{ justify: "center" }}
          gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}
        >
          <Col xs={24} sm={24} md={12}>
            <Form.Item
              name="phone"
              label={<span style={labelStyle}>Phone</span>}
            >
              {getFieldDecorator("phone", {
                initialValue: initialFormData.phone,
                rules: [
                  {
                    validator: this.validatePhoneNumber,
                  },
                ],
              })(<PhoneInputDropdown />)}
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  }
}

const WrappedShipperBasicForm = Form.create({ name: "shipper_basic_info_form" })(
  ShipperBasicForm
);

ShipperBasicForm.propTypes = {
  final_search_form: PropTypes.object,
  queryParams: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
    jwt_token:state.route.JWT_TOKEN.JWT_TOKEN,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedShipperBasicForm)
);
